<template>
  <div class="card-body p-xl-40">
    <h6 class="card-title fw-semiBold fs-18 mb-30">Stock Bajo (≤ 3 unidades)</h6>
    <div class="table-responsive style-five">
      <table class="table text-nowrap align-middle mb-0">
        <thead>
          <tr>
            <th class="text-title fw-normal fs-14 pt-0 ps-0">PRODUCTO</th>
            <th class="text-title fw-normal fs-14 pt-0">PRESENTACIÓN</th>
            <th class="text-title fw-normal fs-14 pt-0">SEDE</th>
            <th class="text-title fw-normal fs-14 pt-0 pe-0">STOCK</th>
          </tr>
        </thead>
        <tbody>
          <template v-if="loading">
            <tr v-for="n in 5" :key="n">
              <td colspan="4"><div class="placeholder-glow"><span class="placeholder col-12 rounded-1" style="height:18px"></span></div></td>
            </tr>
          </template>
          <tr v-else-if="!items.length">
            <td colspan="4" class="text-center text-muted py-3 fs-14">Sin alertas de stock</td>
          </tr>
          <tr v-else v-for="(item, i) in items" :key="i">
            <td class="shadow-none fs-14 fw-semibold text-paragraph ps-0">{{ item.producto }}</td>
            <td class="shadow-none fs-14 fw-normal text-paragraph">{{ item.presentacion }}</td>
            <td class="shadow-none fs-14 fw-normal text-paragraph">{{ item.almacen }}</td>
            <td class="shadow-none fs-14 fw-bold text-danger pe-0">{{ item.stock }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import api from '../../services/api';

export default {
  name: 'StockAlert',
  data() { return { items: [], loading: true }; },
  async mounted() {
    try {
      const res = await api.get('/dashboard');
      this.items = res.data.data.stockBajo || [];
    } catch (e) {
      console.error('StockAlert', e);
    } finally {
      this.loading = false;
    }
  },
};
</script>
